import React from 'react';
import classNames from 'classnames';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useIntl } from '../../../util/reactIntl';
import { createResourceLocatorString } from '../../../util/routes';
import { createSlug } from '../../../util/urlHelpers';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import {
  getAddressObjectId,
  getAuthorShippingPreference,
  getSellerShippingPreference,
} from '../../../util/dataExtractors';

import IconTickMark from '../../../components/IconTickMark/IconTickMark';
import { getCheckoutStepConfig, isValidCheckoutStep } from '../checkoutSteps';
import css from './ProgressInTopbar.module.css';

function ProgressInTopbar() {
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const routeConfiguration = useRouteConfiguration();
  const { listing, orderData } = useSelector(state => state?.CheckoutPage || {});

  const isCheckoutRoute = location?.pathname?.includes('/checkout/');
  if (!isCheckoutRoute) {
    return null;
  }

  const authorShippingPreference = getAuthorShippingPreference(listing?.author);
  const orderDeliveryMethod = orderData?.deliveryMethod;
  const sellerShippingType = getSellerShippingPreference(listing?.author);
  const isShippoEnabled = Boolean(getAddressObjectId(listing?.author));
  const { steps } = getCheckoutStepConfig({
    orderDeliveryMethod,
    sellerShippingType,
    authorShippingPreference,
    isShippoEnabled,
    listing,
  });

  const tabParam = params?.tab;
  const activeStep = isValidCheckoutStep(steps, tabParam) ? tabParam : steps?.[0]?.key;
  const activeStepIndex = steps.findIndex(tab => tab.key === activeStep);

  const handleStepClick = stepKey => {
    if (!listing?.id?.uuid) {
      return;
    }

    history.push(
      createResourceLocatorString(
        'CheckoutPage',
        routeConfiguration,
        {
          id: listing.id.uuid,
          slug: createSlug(listing?.attributes?.title),
          tab: stepKey,
        },
        {}
      )
    );
  };

  return (
    <div className={css.orderStepsContainer}>
      {steps.map((step, index) => {
        const isPastStep = activeStepIndex > index;
        const isCurrentStep = activeStepIndex === index;
        return (
          <div
            key={step.key}
            className={classNames(css.orderSteps, {
              [css.stepCompleted]: isCurrentStep,
              [css.tabDisabled]: !isPastStep,
            })}
            onClick={isPastStep ? () => handleStepClick(step.key) : undefined}
          >
            {isPastStep ? (
              <span className={css.stepCompleted}>
                <IconTickMark />
              </span>
            ) : (
              <span className={css.stepCount}>{index + 1}</span>
            )}
            <span className={css.stepName}>
              {intl.formatMessage({ id: step.labelKey })}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default ProgressInTopbar;
